// FarmSelect.jsx
import { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslation } from "react-i18next";
import api from '../api/api';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "44px",
    borderRadius: "10px",
    borderColor: state.isFocused ? "var(--sf-brand-700, #1d8290)" : "var(--sf-line, #e5ebef)",
    boxShadow: state.isFocused ? "0 0 0 3px var(--sf-brand-100, #e8f7f9)" : "none",
    "&:hover": {
      borderColor: "var(--sf-brand-500, #26a6b7)",
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "var(--sf-brand-700, #1d8290)"
      : state.isFocused
      ? "var(--sf-brand-100, #e8f7f9)"
      : "transparent",
    color: state.isSelected ? "#ffffff" : "var(--sf-ink-900, #23364d)",
  }),
};

const FarmSelect = ({ userUid, onChange, url, placeholder, defaultval }) => {
  const { t } = useTranslation();
  const [loadError, setLoadError] = useState(false);

  // Load options as the user types
  const loadOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];

    try {
      const res = await api.get(url, {
        params: { search: inputValue }
      });
      setLoadError(false);
      return res.data; // already formatted as { value, label }
    } catch (err) {
      console.error("Failed to fetch farms", err);
      setLoadError(true);
      return [];
    }
  };

  return (
    <div>
      {defaultval.value ? (
        <AsyncSelect
          cacheOptions
          loadOptions={loadOptions}
          defaultOptions={false}
          placeholder={placeholder}
          onChange={onChange}
          defaultValue={defaultval}
          styles={selectStyles}
        />
      ) : (
        <AsyncSelect
          cacheOptions
          loadOptions={loadOptions}
          defaultOptions={false}
          placeholder={placeholder}
          onChange={onChange}
          styles={selectStyles}
        />
      )}
      {loadError && (
        <small className="text-danger d-block mt-1">
          {t("load_options_error", { defaultValue: "Unable to load results. Please try again." })}
        </small>
      )}
    </div>
  );
};

export default FarmSelect;
